import { render, staticRenderFns } from "./PIAChatbot.vue?vue&type=template&id=b5f52dc8&scoped=true&"
import script from "./PIAChatbot.vue?vue&type=script&lang=js&"
export * from "./PIAChatbot.vue?vue&type=script&lang=js&"
import style0 from "./PIAChatbot.vue?vue&type=style&index=0&id=b5f52dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f52dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VTextField})
